// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-bar {
  margin-bottom: 20px;
}
.top-bar ds-icon {
  cursor: pointer;
}

.more-menu__wrapper {
  background-color: rgba(0, 0, 0, 0.4);
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 1000;
}
.more-menu__wrapper .more-menu {
  bottom: 93px;
  border-radius: 13px;
  left: 12px;
  position: absolute;
  width: calc(100% - 24px);
  z-index: 100;
}
.more-menu__wrapper .more-menu__header {
  align-items: center;
  background: #f5f5f5;
  border-top-left-radius: 13px;
  border-top-right-radius: 13px;
  display: flex;
  flex-wrap: wrap;
}
.more-menu__wrapper .more-menu__header__avatar {
  background-color: #ffffff;
  border: 1px solid #a7893d;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  margin: 20px 0 20px 20px;
  height: 75px;
  text-align: center;
  width: 75px;
}
.more-menu__wrapper .more-menu__header__user-detail {
  display: flex;
  flex-direction: column;
  margin: 20px 0 20px 0;
  padding: 8px;
}
.more-menu__wrapper .more-menu__header__logout-button {
  background: transparent;
  border-top: 1px solid #dedede;
  border-style: solid none none none;
  cursor: pointer;
  padding: 19px;
  width: 100%;
}
.more-menu__wrapper .more-menu__header__logout-button ds-text {
  text-transform: uppercase;
}
.more-menu__wrapper .more-menu__button-list {
  display: flex;
  flex-direction: column;
  justify-content: center;
  list-style: none;
}
.more-menu__wrapper .more-menu__button-list__button {
  background: #ffffff;
  border-top: 1px solid #dedede;
  cursor: pointer;
  padding: 19px;
  text-align: center;
}
.more-menu__wrapper .more-menu__button-list__button:first-child {
  cursor: default;
  display: flex;
  flex-direction: column;
}
.more-menu__wrapper .more-menu__button-list__button:first-child .vertreter-dropdown-header {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding-bottom: 2px;
}
@media (max-width: 992px) {
  .more-menu__wrapper .more-menu__button-list__button:first-child .vertreter-dropdown-header {
    justify-content: center;
  }
  .more-menu__wrapper .more-menu__button-list__button:first-child .vertreter-dropdown-header ds-icon {
    margin-left: 24px;
  }
}
.more-menu__wrapper .more-menu__button-list__button:first-child .hauptbenutzer-array-container {
  padding-top: 8px;
}
.more-menu__wrapper .more-menu__button-list__button:first-child .hauptbenutzer-array-container.hidden {
  display: none;
}
.more-menu__wrapper .more-menu__button-list__button:first-child .hauptbenutzer-array-container .hauptbenutzer {
  cursor: pointer;
}
.more-menu__wrapper .more-menu__button-list__button.umstellungsfaehigkeit {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.more-menu__wrapper .more-menu__button-list__button ds-yes-no {
  padding-top: 12px;
}
.more-menu__wrapper .more-menu__button-list__button:active {
  background: #f5f5f5;
}
.more-menu__wrapper .more-menu__button-list__button.close {
  background: #f5f5f5;
  border-radius: 0 0 13px 13px;
}
.more-menu__wrapper .more-menu__button-list__button.close ds-text {
  color: #a7893d;
  text-transform: uppercase;
}
.more-menu__wrapper .more-menu__button-list__button.close:active {
  background: #dedede;
}
.more-menu__wrapper .more-menu__button-list__button.version {
  cursor: default;
}
.more-menu__wrapper .more-menu__button-list__button.version:active {
  background: #ffffff;
}
@media (min-width: 992px) {
  .more-menu__wrapper {
    height: 0;
  }
  .more-menu__wrapper .more-menu {
    bottom: auto;
    border-radius: 6px;
    left: auto;
    filter: drop-shadow(0 0 12px rgba(0, 0, 0, 0.16));
    max-width: 240px;
    right: 16px;
    top: 50px;
    z-index: 1000;
  }
  .more-menu__wrapper .more-menu:before {
    background: transparent;
    border: 16px solid transparent;
    content: " ";
    height: 0;
    position: absolute;
    right: 8px;
    width: 0;
    z-index: 10;
  }
  .more-menu__wrapper .more-menu__header {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }
  .more-menu__wrapper .more-menu__button-list li:nth-of-type(2) .more-menu__button {
    border-top: none;
  }
  .more-menu__wrapper .more-menu__button-list__button {
    text-align: left;
  }
  .more-menu__wrapper .more-menu__button-list__button.close {
    display: none;
    height: auto;
  }
  .more-menu__wrapper .more-menu__button-list__button.version {
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
  }
}
@media (min-width: 1200px) {
  .more-menu__wrapper__content {
    display: flex;
    height: 0;
    justify-content: flex-end;
    margin: 0 auto;
    width: 1200px;
  }
  .more-menu__wrapper .more-menu {
    margin-top: 60px;
    margin-right: -8px;
    position: static;
    z-index: 100;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/more-menu/more-menu.component.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAEA;EACE,mBAAA;AADF;AAGE;EACE,eAAA;AADJ;;AAKA;EACE,oCAAA;EACA,YAAA;EACA,OAAA;EACA,eAAA;EACA,MAAA;EACA,YAAA;EACA,aAAA;AAFF;AAIE;EACE,YAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,wBAAA;EACA,YAAA;AAFJ;AAII;EACE,mBAAA;EACA,mBCHmB;EDInB,4BAAA;EACA,6BAAA;EACA,aAAA;EACA,eAAA;AAFN;AAIM;EACE,yBCpBW;EDqBX,yBAAA;EACA,kBAAA;EACA,0BAAA;EACA,uBAAA;EACA,wBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAFR;AAKM;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,YAAA;AAHR;AAMM;EACE,uBAAA;EACA,6BAAA;EACA,kCAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;AAJR;AAMQ;EACE,yBAAA;AAJV;AASI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;AAPN;AASM;EACE,mBC3DW;ED4DX,6BAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;AAPR;AAUQ;EACE,eAAA;EACA,aAAA;EACA,sBAAA;AARV;AAUU;EACE,eAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AARZ;AAUY;EANF;IAOI,uBAAA;EAPZ;EASY;IACE,iBAAA;EAPd;AACF;AAWU;EACE,gBAAA;AATZ;AAWY;EACE,aAAA;AATd;AAYY;EACE,eAAA;AAVd;AAgBQ;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;AAdV;AAiBQ;EACE,iBAAA;AAfV;AAkBQ;EACE,mBCrGe;ADqFzB;AAmBQ;EACE,mBCzGe;ED0Gf,4BAAA;AAjBV;AAmBU;EACE,cC7HM;ED8HN,yBAAA;AAjBZ;AAoBU;EACE,mBCpHa;ADkGzB;AAqBQ;EACE,eAAA;AAnBV;AAqBU;EACE,mBCnIO;ADgHnB;AA0BE;EAhJF;IAiJI,SAAA;EAvBF;EAyBE;IACE,YAAA;IACA,kBAAA;IACA,UAAA;IACA,iDAAA;IACA,gBAAA;IACA,WAAA;IACA,SAAA;IACA,aAAA;EAvBJ;EAyBI;IACE,uBAAA;IACA,8BAAA;IACA,YAAA;IACA,SAAA;IACA,kBAAA;IACA,UAAA;IACA,QAAA;IACA,WAAA;EAvBN;EA0BI;IACE,2BAAA;IACA,4BAAA;EAxBN;EA4BM;IACE,gBAAA;EA1BR;EA6BM;IACE,gBAAA;EA3BR;EA6BQ;IACE,aAAA;IACA,YAAA;EA3BV;EA6BQ;IACE,8BAAA;IACA,+BAAA;EA3BV;AACF;AAiCE;EACE;IACE,aAAA;IACA,SAAA;IACA,yBAAA;IACA,cAAA;IACA,aAAA;EA/BJ;EAiCE;IACE,gBAAA;IACA,kBAAA;IACA,gBAAA;IACA,YAAA;EA/BJ;AACF","sourcesContent":["@import \"../../styles/variables\";\n\n.top-bar {\n  margin-bottom: 20px;\n\n  ds-icon {\n    cursor: pointer;\n  }\n}\n\n.more-menu__wrapper {\n  background-color: rgba(0, 0, 0, 0.4);\n  height: 100%;\n  left: 0;\n  position: fixed;\n  top: 0;\n  width: 100vw;\n  z-index: 1000;\n\n  .more-menu {\n    bottom: calc(24px + 12px + 57px);\n    border-radius: 13px;\n    left: 12px;\n    position: absolute;\n    width: calc(100% - 24px);\n    z-index: 100;\n\n    &__header {\n      align-items: center;\n      background: $DVAG-color-hellgrau-95;\n      border-top-left-radius: 13px;\n      border-top-right-radius: 13px;\n      display: flex;\n      flex-wrap: wrap;\n\n      &__avatar {\n        background-color: $DVAG-color-weiss;\n        border: 1px solid $DVAG-color-gold;\n        border-radius: 50%;\n        -webkit-border-radius: 50%;\n        -moz-border-radius: 50%;\n        margin: 20px 0 20px 20px;\n        height: 75px;\n        text-align: center;\n        width: 75px;\n      }\n\n      &__user-detail {\n        display: flex;\n        flex-direction: column;\n        margin: 20px 0 20px 0;\n        padding: 8px;\n      }\n\n      &__logout-button {\n        background: transparent;\n        border-top: 1px solid $DVAG-color-hellgrau-85;\n        border-style: solid none none none;\n        cursor: pointer;\n        padding: 19px;\n        width: 100%;\n\n        ds-text {\n          text-transform: uppercase;\n        }\n      }\n    }\n\n    &__button-list {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      list-style: none;\n\n      &__button {\n        background: $DVAG-color-weiss;\n        border-top: 1px solid $DVAG-color-hellgrau-85;\n        cursor: pointer;\n        padding: 19px;\n        text-align: center;\n\n        // Styles for Hauptbenutzer. Remove cursor:pointer for hauptbenutzer-container, add cursor:pointer for clickable hauptbenutzer\n        &:first-child {\n          cursor: default;\n          display: flex;\n          flex-direction: column;\n\n          .vertreter-dropdown-header {\n            cursor: pointer;\n            display: flex;\n            justify-content: space-between;\n            padding-bottom: 2px;\n\n            @media (max-width: $DVAG-breakpoint-LG) {\n              justify-content: center;\n\n              ds-icon {\n                margin-left: 24px;\n              }\n            }\n          }\n\n          .hauptbenutzer-array-container {\n            padding-top: 8px;\n\n            &.hidden {\n              display: none;\n            }\n\n            .hauptbenutzer {\n              cursor: pointer;\n            }\n          }\n        }\n\n        // Styles for test-button: Umstellungsfähigkeitsaktualisierung\n        &.umstellungsfaehigkeit {\n          display: flex;\n          align-items: center;\n          flex-direction: column;\n        }\n\n        ds-yes-no {\n          padding-top: 12px;\n        }\n\n        &:active {\n          background: $DVAG-color-hellgrau-95;\n        }\n\n        &.close {\n          background: $DVAG-color-hellgrau-95;\n          border-radius: 0 0 13px 13px;\n\n          ds-text {\n            color: $DVAG-color-gold;\n            text-transform: uppercase;\n          }\n\n          &:active {\n            background: $DVAG-color-hellgrau-85;\n          }\n        }\n        &.version {\n          cursor: default;\n\n          &:active {\n            background: $DVAG-color-weiss;\n          }\n        }\n      }\n    }\n  }\n\n  @media (min-width: $DVAG-breakpoint-LG) {\n    height: 0;\n\n    .more-menu {\n      bottom: auto;\n      border-radius: 6px;\n      left: auto;\n      filter: drop-shadow(0 0 12px rgba(0, 0, 0, 0.16));\n      max-width: 240px;\n      right: 16px;\n      top: 50px;\n      z-index: 1000;\n\n      &:before {\n        background: transparent;\n        border: 16px solid transparent;\n        content: \" \";\n        height: 0;\n        position: absolute;\n        right: 8px;\n        width: 0;\n        z-index: 10;\n      }\n\n      &__header {\n        border-top-left-radius: 6px;\n        border-top-right-radius: 6px;\n      }\n\n      &__button-list {\n        li:nth-of-type(2) .more-menu__button {\n          border-top: none;\n        }\n\n        &__button {\n          text-align: left;\n\n          &.close {\n            display: none;\n            height: auto;\n          }\n          &.version {\n            border-bottom-left-radius: 6px;\n            border-bottom-right-radius: 6px;\n          }\n        }\n      }\n    }\n  }\n\n  @media (min-width: $DVAG-breakpoint-XL) {\n    &__content {\n      display: flex;\n      height: 0;\n      justify-content: flex-end;\n      margin: 0 auto;\n      width: 1200px;\n    }\n    .more-menu {\n      margin-top: 60px;\n      margin-right: -8px;\n      position: static;\n      z-index: 100;\n    }\n  }\n}\n","$DVAG-fontweight-regular: 400;\n$DVAG-fontweight-medium: 500;\n$DVAG-fontweight-bold: 700;\n\n$DVAG-breakpoint-SM: 576px;\n$DVAG-breakpoint-MD: 768px;\n$DVAG-breakpoint-LG: 992px;\n$DVAG-breakpoint-XL: 1200px;\n\n// Primaerfarbe\n$DVAG-color-gold: #a7893d;\n$DVAG-color-gold-dunkel: #856d30;\n$DVAG-color-gold-mittel: #957b36;\n$DVAG-color-gold-hell: #e3dac4;\n\n// Sekundaerfarbe\n$DVAG-color-weiss: #ffffff;\n\n// Grautoene\n$DVAG-color-anthrazit: #424242;\n$DVAG-color-dunkelgrau-30: #4c4c4c;\n$DVAG-color-dunkelgrau-40: #666666;\n$DVAG-color-dunkelgrau-50: #7f7f7f;\n$DVAG-color-dunkelgrau-70: #c1c1c1;\n$DVAG-color-hellgrau-85: #dedede;\n$DVAG-color-hellgrau-90: #ebebeb;\n$DVAG-color-hellgrau-95: #f5f5f5;\n$DVAG-color-hellgrau-98: #979797;\n\n// Gestaltungsfarben\n$DVAG-color-dunkelblau: #004165;\n$DVAG-color-dunkelblau-80: #336783;\n$DVAG-color-dunkelblau-60: #668da2;\n$DVAG-color-dunkelblau-40: #99b3c1;\n$DVAG-color-dunkelblau-20: #ccd9e0;\n\n$DVAG-color-rot: #be1413;\n$DVAG-color-rot-80: #cb4342;\n$DVAG-color-rot-60: #d87271;\n$DVAG-color-rot-40: #e5a1a0;\n$DVAG-color-rot-20: #f2d0cf;\n\n$DVAG-color-petrol: #3b94a3;\n$DVAG-color-petrol-80: #62a9b5;\n$DVAG-color-petrol-60: #89bec7;\n$DVAG-color-petrol-40: #b0d4da;\n$DVAG-color-petrol-20: #d7e9ec;\n\n$DVAG-color-gelb: #e8b50e;\n$DVAG-color-gelb-80: #ecc33e;\n$DVAG-color-gelb-60: #f1d26e;\n$DVAG-color-gelb-40: #f5e19e;\n$DVAG-color-gelb-20: #faf0ce;\n\n$DVAG-color-gruen: #6ea318;\n$DVAG-color-gruen-80: #8bb546;\n$DVAG-color-gruen-60: #a8c774;\n$DVAG-color-gruen-40: #c5daa2;\n$DVAG-color-gruen-20: #e2ecd0;\n\n// Transparenzen\n$DVAG-boxshadow-header: 0px -4px 12px 0px rgba(0, 0, 0, 0.16);\n$DVAG-boxshadow-toolbar: 0px 4px 12px 0px rgba(0, 0, 0, 0.16);\n$DVAG-boxshadow-tooltip: 0px 4px 12px 2px rgba(0, 0, 0, 0.16);\n$DVAG-boxshadow-fehlertooltip: 0px 4px 12px 0px rgba(0, 0, 0, 0.32);\n$DVAG-boxshadow-modal-view: 0px 0px 30px 0px rgba(0, 0, 0, 0.16);\n$DVAG-boxshadow-modal-view-hintergrund: rgba(102, 102, 102, 0.6);\n$DVAG-boxshadow-alert-grundflaeche: rgba(255, 255, 255, 0.5) rgba(252, 252, 252, 0.8);\n\n$spacing: (\n  margin: (\n    m-8: 8px,\n    m-16: 16px,\n    m-24: 24px,\n    m-32: 32px,\n    m-48: 48px,\n    m-64: 64px,\n  ),\n  padding: (\n    p-8: 8px,\n    p-16: 16px,\n    p-24: 24px,\n    p-32: 32px,\n    p-48: 48px,\n    p-64: 64px,\n  ),\n);\n\n$inputBorderRadius: 4px;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
